import { Container } from "@dinahmoe/dmafjs-visual";
import { nodes } from "@dinahmoe/dmafjs-core";

class NetworkCase extends Container {
  namespace = "network:case";

  handlers = {
    selected: this.handleSelectedChange
  };

  init(node, event) {
    super.init(node, event);
    const content = this.wrapText(node.caseName, node.maxCharsPerLine);
    if (!node._ids["case_name"]) {
      console.warn("network:case missing child 'case_name' — created without template children");
      return;
    }
    node._ids["case_name"]["text.content"] = content;
  }

  wrapText(text, maxChars) {
    if (!maxChars || maxChars <= 0) {
      return text;
    }

    const words = text.split(" ");
    const lines = [];
    let currentLine = "";

    for (const word of words) {
      const testLine = currentLine ? `${currentLine} ${word}` : word;

      if (testLine.length <= maxChars) {
        currentLine = testLine;
      } else {
        if (currentLine) {
          lines.push(currentLine);
        }
        currentLine = word;
      }
    }

    if (currentLine) {
      lines.push(currentLine);
    }

    return lines.join("<br>");
  }

  handleSelectedChange(node) {
    const plate = node._ids["plate"];
    const caseName = node._ids["case_name"];
    const icon = node._ids["icon"];

    if (node.selected) {
      if (plate) {
        plate["appearance.background"] = "rgba(255,255,255, 1)";
        plate["appearance.backdropBlur"] = 0;
        plate["border.width"] = 0;
      }
      if (caseName) caseName["text.color"] = "#CD288C";
      if (icon) {
        icon["source.imageId"] = "icon_minus";
        icon["source.fill"] = "#CD288C";
      }
    } else {
      if (plate) {
        plate["appearance.background"] = "rgba(255,255,255, 0.1)";
        plate["appearance.backdropBlur"] = 10;
        plate["border.width"] = 1;
      }
      if (caseName) caseName["text.color"] = "#FFFFFF";
      if (icon) {
        icon["source.imageId"] = "icon_plus_white";
        icon["source.fill"] = "white";
      }
    }
  }

  receiveMessage(node, message) {
    super.receiveMessage(node, message);

    // Forward click events to container
    if (message.key === "click" && node.containerUid) {
      const containerNode = nodes.get(node.containerUid);
      if (containerNode) {
        containerNode.tell({
          type: "case_clicked",
          caseUid: node.uid
        });
      } else {
        console.error("[network-case] container not found", node.containerUid);
      }
    }
  }
}

const networkCase = new NetworkCase();

export { NetworkCase, networkCase };
